module.exports = __webpack_public_path__ + "static/NasiVrhovi-a7e6db6c6520b4048cc7481a92a7ab95.pdf";